import React from 'react';

// sub-components
import Contain from '../contain';

import { Footer, Copywrite, Menu } from './styles';

export default () => {
  return (
    <Footer>
      <Contain textCenter>
        <Menu>
          <a href="https://quickpage.io/terms" rel="noopener noreferrer" target="_blank">Terms of Service</a>
          <span>|</span>
          <a href="https://quickpage.io/privacy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>
          <span>|</span>
          <a href="https://quickpageapp.com/sign-in">Log In</a>
        </Menu>
        <Copywrite>Copyright {(new Date()).getFullYear()} Quickpage Inc, All Rights Reserved.</Copywrite>
      </Contain>
    </Footer>
  )
}
